import { useCallback } from 'react';
import { useAnalyticsClient } from '../useAnalyticsClient';
import { useAnalyticsSession } from '../useAnalyticsSession';
import { useAnalyticsProperty } from '../useAnalyticsProperty';
import { UserActionView } from 'rwl-shared/dist/models/analytics';
import { useAnalyticsTargetLayer } from '../useAnalyticsTargetLayer';
import { useAnalyticsTargetLayerArea } from '../useAnalyticsTargetLayerArea';

type ViewEventProps = Omit<
    UserActionView['data'],
    'targetLayer' | 'targetLayerId' | 'targetLayerArea'
>;

/**
 * Returns a function that, when called, sends a view event to the BI service
 */
export const useAnalyticsViewEvent = () => {
    const { client } = useAnalyticsClient();
    const { session } = useAnalyticsSession();
    const { property } = useAnalyticsProperty();
    const { targetLayer, targetLayerId } = useAnalyticsTargetLayer();
    const { targetLayerArea } = useAnalyticsTargetLayerArea();

    return useCallback(
        (data: ViewEventProps) => {
            if (!client || !session) {
                console.warn(
                    '[RWL] BI client or session is not available, event will be lost'
                );
                return;
            }

            client.createViewAction(session, property, {
                targetLayer,
                targetLayerId,
                targetLayerArea,
                ...data,
            });
        },
        [client, session, property, targetLayer, targetLayerId, targetLayerArea]
    );
};
